// src/pages/personal/analytics/FeedbackSection/components/RecommendationStats/RecommendChart.tsx
import React from 'react';
import { PieChart as PieChartComponent } from '@/components/ui/Charts';
import { formatNumber, formatPercent } from '@/utils/Formatters';
import { LOCALES } from '@/utils/constants';
import { useTranslation } from 'react-i18next';

interface ChartData {
  name: string;
  value: number;
  percentage: number;
  color: string;
}

interface RecommendChartProps {
  data: ChartData[];
}

export const RecommendChart: React.FC<RecommendChartProps> = ({ data }) => {
  const { i18n } = useTranslation();
  const locale = i18n.language || LOCALES.DEFAULT;
  
  // Преобразуем данные в формат, который ожидает компонент PieChart
  const pieData = data.map(item => ({
    name: item.name,
    value: item.value,
    color: item.color
  }));

  // Функция для форматирования тултипа с использованием форматтеров
  const customTooltipRenderer = (props: any) => {
    const { payload } = props;
    if (!payload || !payload.length) return null;

    const item = payload[0];
    const chartItem = data.find(d => d.name === item.name);
    if (!chartItem) return null;

    return (
      <div className="bg-white p-2 border rounded shadow text-sm">
        <div className="font-medium">{item.name}</div>
        <div>
          {formatNumber(item.value, 0, true, locale)} 
          ({formatPercent(chartItem.percentage, 1, true, locale)})
        </div>
      </div>
    );
  };

  return (
    <PieChartComponent
      data={pieData}
      innerRadius={30}
      outerRadius={80}
      paddingAngle={2}
      showLabels={true}
      showLegend={false}
      tooltip={customTooltipRenderer}
    />
  );
};